import { formatDate } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Params } from '@angular/router';
import { saveAs } from 'file-saver-es';
import { SortData } from 'src/app/_models/common/sortData';
import { DriverModel } from 'src/app/_models/driver/driver';
import { TableType } from 'src/app/_models/enums/tableType';
import { EscrowCreateRequest } from 'src/app/_models/escrow/escrowCreateRequest';
import { EscrowViewModel } from 'src/app/_models/escrow/escrowViewModel';
import { TruckModel } from 'src/app/_models/truck';
import { UserModel } from 'src/app/_models/user';
import {
  DriverService,
  EscrowService,
  LoanService,
  PayrollService,
  ToastrTranslateService,
  TruckService,
  UserService,
} from 'src/app/_services';
import { LocalStorageSortService } from 'src/app/_services/local.storage.sort.service';
import { ConfirmDeleteEscrowDialogComponent } from '../../confirm-delete-escrow-dialog/confirm-delete-escrow-dialog.component';

@Component({
  selector: 'app-payroll-escrow',
  templateUrl: './payroll-escrow.component.html',
  styleUrls: ['./payroll-escrow.component.scss'],
})
export class PayrollEscrowComponent implements OnInit, AfterViewInit {
  campaignOne: UntypedFormGroup;
  @ViewChild(MatSort) sort: MatSort;

  positiveAdjustmentReason: string | null = null;
  positiveAmount: number | null = null;
  loan: number | null = null;

  negativeAmount: number | null = null;
  negativeAdjustmentReason: string | null = null;
  totalEscrow = 0.0;
  driverId = 0;
  sortData: SortData;
  displayedColumns: string[] = [
    'date',
    'userName',
    'reason',
    'adjustment',
    'delete',
    'star',
  ];
  dataSource = new MatTableDataSource<EscrowViewModel>();
  truck: TruckModel;
  total: number;
  truckId: number;
  changedByUser: UserModel;

  public totalAdjustment = 0;
  public form: UntypedFormGroup;
  constructor(
    private route: ActivatedRoute,
    private truckService: TruckService,
    private escrowService: EscrowService,
    private loanService: LoanService,
    private dialog: MatDialog,
    public toastrTranslateService: ToastrTranslateService,
    private localStorageSortService: LocalStorageSortService,
    private builder: UntypedFormBuilder,
    private payrollService: PayrollService,
    private driverService: DriverService,
    private userService: UserService
  ) {
    const today = new Date();
    const month = today.getMonth();
    const year = today.getFullYear();

    this.campaignOne = new UntypedFormGroup({
      start: new UntypedFormControl(new Date(year, month, 13)),
      end: new UntypedFormControl(new Date(year, month, 16)),
    });
    this.form = this.builder.group({
      files: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.changedByUser = new UserModel();
    this.sortData = this.localStorageSortService.getSortData(
      TableType.PayrollEscrow
    );
    this.payrollService.curentTotal.subscribe((total) => (this.total = total));
    this.userService.getAll().subscribe((changedByUser: UserModel) => {
      this.changedByUser = changedByUser;
    });

    this.route.parent.params.subscribe((params: Params) => {
      this.truckId = +params['truckId'];
      this.driverId = +params['driverId'];
      this.truckService
        .getTruck(this.truckId)
        .subscribe((truck: TruckModel) => {
            this.driverService
              .getDriver(this.driverId)
              .subscribe((driver: DriverModel) => {
                truck.driver = driver;
                this.GetTabData(truck);
              });
          
          this.GetTabData(truck);
        });
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.sort.sort({
        id: this.sortData.activeColumn,
        start: this.sortData.order,
      } as MatSortable);
      this.dataSource.sort = this.sort;
    });
    this.dataSource.sortingDataAccessor = (item, property) => {
      this.localStorageSortService.setSortData(
        TableType.PayrollEscrow,
        this.sort
      );
      return item[property];
    };
  }

  private GetTabData(truck: TruckModel) {
    this.truck = truck;
    this.getEscrowList(this.driverId);
    this.getLoans();
  }

  async downloadPdf() {
    try {
      const data = await this.escrowService.getPdfForDriverId(this.driverId);
      const blob = new Blob([data], {
        type: 'application/pdf',
      });
      const fileName =
        this.truck.driver.firstname +
        '_' +
        this.truck.driver.lastname +
        '-' +
        formatDate(Date.now(), 'yyyy_MM_dd-h_mm', 'en-US') +
        '-escrows.pdf';
      saveAs(blob, fileName);
    } catch (error) {
      this.toastrTranslateService.error(error, 'COMMON.ERROR_DATA');
    }
  }
  getLoans() {
    this.loanService.getLoans(this.truck.driver.id).subscribe((loans) => {
      this.loan = loans.map((l) => l.adjustment).reduce((a, b) => a + b, 0);
      this.setTotalsAdjustment();
    });
  }

  setTotalsAdjustment() {
    this.totalAdjustment = this.getTotalAdjustment();
  }

  getTotalAdjustment() {
    return this.dataSource.data
      .map((t) => t.adjustment)
      .reduce((acc, value) => acc + value, 0);
  }

  calculateTotalEscrow() {
    this.dataSource.data.length > 0
      ? (this.totalEscrow = this.dataSource.data
          .map((l) => l.adjustment)
          .reduce((a, b) => a + b))
      : (this.totalEscrow = 0);
    this.setTotalsAdjustment();
  }

  addPositiveAdjustment(isInvalid) {
    if (!isInvalid && this.positiveAdjustmentReason && this.positiveAmount) {
      const request: EscrowCreateRequest = {
        driverId: this.driverId,
        adjustment:
          this.positiveAmount < 0 ? this.positiveAmount : -this.positiveAmount,
        reason: this.positiveAdjustmentReason,
        date: new Date(),
      };
      this.escrowService.addEscrow(request).subscribe((_) => {
        this.getEscrowList(this.driverId);
        this.clear();
      });
    } else {
      this.toastrTranslateService.warning('GENERAL.FORM_INVALID');
    }
  }
  addNegativeAdjustment(isInvalid) {
    if (!isInvalid && this.negativeAdjustmentReason && this.negativeAmount) {
      const request: EscrowCreateRequest = {
        driverId: this.driverId,
        adjustment: this.negativeAmount,
        reason: this.negativeAdjustmentReason,
        date: new Date(),
      };
      this.escrowService.addEscrow(request).subscribe((_) => {
        this.getEscrowList(this.driverId);
        this.clear();
      });
    } else {
      this.toastrTranslateService.warning('GENERAL.FORM_INVALID');
    }
  }
  deleteEscrow(escrow: EscrowViewModel) {
    const dialogRef = this.dialog.open(ConfirmDeleteEscrowDialogComponent, {
      width: '450px',
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.escrowService.deleteEscrow(escrow.id).subscribe((res) => {
          this.toastrTranslateService.success('CONFIRM_DIALOG.SUCCESS_DELL');
          this.getEscrowList(this.driverId);
        });
      }
    });
  }
  getEscrowList(driverId: number) {
    this.escrowService.getEscrows(driverId).subscribe((escrows) => {
      this.dataSource.data = escrows.map((escrow) => {
        return {
          id: escrow.id,
          date: escrow.date,
          driverName: `${escrow.driver.firstname} ${escrow.driver.lastname}`,
          userName: `${escrow?.changedByUser?.firstname} ${escrow?.changedByUser?.lastname}`,
          reason: escrow.reason,
          adjustment: escrow.adjustment,
        };
      });
      this.calculateTotalEscrow();
    });
  }

  refresh() {
    this.getEscrowList(this.driverId);
  }

  clear() {
    this.negativeAmount = null;
    this.negativeAdjustmentReason = null;
    this.positiveAdjustmentReason = null;
    this.positiveAmount = null;
  }
}
